module.exports = __webpack_public_path__ + "static/media/V.0fda59e4.png";